import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Async thunks
export const fetchAdvertisements = createAsyncThunk(
  'advertisement/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get('/advertisements', { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch advertisements');
    }
  }
);

export const fetchAdvertisementById = createAsyncThunk(
  'advertisement/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/advertisements/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch advertisement');
    }
  }
);

export const createAdvertisement = createAsyncThunk(
  'advertisement/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post('/advertisements', data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create advertisement');
    }
  }
);

export const updateAdvertisement = createAsyncThunk(
  'advertisement/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/advertisements/${id}`, data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to update advertisement');
    }
  }
);

export const deleteAdvertisement = createAsyncThunk(
  'advertisement/delete',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/advertisements/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete advertisement');
    }
  }
);

const advertisementSlice = createSlice({
  name: 'advertisement',
  initialState: {
    advertisements: [],
    currentAdvertisement: null,
    loading: false,
    error: null,
    pagination: { page: 1, size: 10, total: 0 },
  },
  reducers: {
    clearCurrentAdvertisement: (state) => {
      state.currentAdvertisement = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvertisements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdvertisements.fulfilled, (state, action) => {
        state.loading = false;
        state.advertisements = action.payload.data || [];
        state.pagination = action.payload.pagination || state.pagination;
      })
      .addCase(fetchAdvertisements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAdvertisementById.fulfilled, (state, action) => {
        state.currentAdvertisement = action.payload;
      })
      .addCase(createAdvertisement.fulfilled, (state, action) => {
        state.advertisements.unshift(action.payload);
      })
      .addCase(updateAdvertisement.fulfilled, (state, action) => {
        const index = state.advertisements.findIndex(ad => ad.id === action.payload.id);
        if (index !== -1) state.advertisements[index] = action.payload;
      })
      .addCase(deleteAdvertisement.fulfilled, (state, action) => {
        state.advertisements = state.advertisements.filter(ad => ad.id !== action.payload);
      });
  },
});

export const { clearCurrentAdvertisement, clearError } = advertisementSlice.actions;
export default advertisementSlice.reducer;
